import { CountyProps } from '@/models/County';
import { ProgramNames } from '@/models/Program';
import { StateProps } from '@/models/State';
import { UserType } from '@/models/User';

import { DomesticAssignmentFields } from './DomesticAssignmentFields';
import { InternationalAssignmentFields } from './InternationalAssignmentFields';

export function AssignmentSection({
  type,
  states,
  selectedPrograms,
  onProgramsChange,
  selectedCountries,
  onCountriesChange,
  selectedState,
  onStateChange,
  selectedCounties,
  onCountiesChange,
  countiesInState,
}: {
  type: UserType;
  states: StateProps[];
  selectedPrograms: ProgramNames[];
  onProgramsChange: (programIds: ProgramNames[]) => void;
  selectedCountries: number[];
  onCountriesChange: (countryIds: number[]) => void;
  selectedState: string | null;
  onStateChange: (stateId: string | null) => void;
  selectedCounties: string[];
  onCountiesChange: (countyIds: string[]) => void;
  countiesInState: CountyProps[];
}) {
  if (type === UserType.NationalProgrammeLead) {
    return (
      <InternationalAssignmentFields
        selectedPrograms={selectedPrograms}
        onProgramsChange={onProgramsChange}
        selectedCountries={selectedCountries}
        onCountriesChange={onCountriesChange}
      />
    );
  }

  return (
    <DomesticAssignmentFields
      type={type}
      states={states}
      selectedPrograms={selectedPrograms}
      onProgramsChange={onProgramsChange}
      selectedState={selectedState}
      onStateChange={onStateChange}
      selectedCounties={selectedCounties}
      onCountiesChange={onCountiesChange}
      countiesInState={countiesInState}
    />
  );
}
